var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgArrowRightWhite = function SvgArrowRightWhite(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    fill: "#fff",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#arrow_right_white_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.45 10.613a.527.527 0 0 1-.143-.35.458.458 0 0 1 .144-.35l3.937-3.937-3.937-3.938a.489.489 0 0 1-.144-.344.465.465 0 0 1 .144-.356.467.467 0 0 1 .343-.156.465.465 0 0 1 .357.144l4.387 4.387a.38.38 0 0 1 .088.125.367.367 0 0 1 .025.138c0 .05-.009.095-.025.137a.38.38 0 0 1-.088.125l-4.387 4.388a.466.466 0 0 1-.344.137.487.487 0 0 1-.356-.15Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "arrow_right_white_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h12v12H0z"
  })))));
};
export default SvgArrowRightWhite;